module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    ref: "input1",
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1
    }
  }, [_c('div', {
    staticClass: "ws-selectTree"
  }, [_c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.treeData,
      "props": _vm.props,
      "node-key": "id",
      "highlight-current": ""
    },
    on: {
      "node-click": _vm.handleNodeClick
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-3879527c!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/select-tree/src/index.vue
// module id = 304
// module chunks = 99 100